import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import FileInput from 'vendor/file_input'
import InputMask from 'react-input-mask'
import { isValidNumber } from 'libphonenumber-js'
import XRegExp from 'xregexp'

import { byteLength, truncateIcc } from 'components/dashboard/shared/util'
import createAxios from 'utils/axios'
import Confirmation from './confirmation'
import { MAX_LENGTH_REGISTER } from 'components/dashboard/constants/max_length'

// Constants
import {
  DEFAULT_LOCALE,
  CHINA_REGION,
  JAPAN_LOCALE,
  validLatinChars,
} from 'components/dashboard/constants'
import sortedCountriesList from '../../../helpers/sorted_countries_list'

const Hint = props => <span style={{ color: '#eee' }}>{props.hint}</span>

class Register extends Component {
  constructor(props) {
    super(props)

    const isChina = props.region === CHINA_REGION
    const email = !isChina ? props.login : ''
    const phone = isChina ? props.login : ''

    this.state = {
      firstName: '',
      lastName: '',
      email,
      // confirmEmail: email,
      phone,
      // confirmPhone: phone,
      password: '',
      confirmPassword: '',
      country: '',
      agree: false,
      identity: '',
      message: '',
      fetching: false,
      valid: false,
      errorFields: {},
      confirmation: false,
      maxLength: { ...MAX_LENGTH_REGISTER },
      blurOnce: false,
      isChina,
    }

    this.changeHandler = this.changeHandler.bind(this)
    this.focusHandler = this.focusHandler.bind(this)
    this.blurHandler = this.blurHandler.bind(this)
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  hintFor(translationCode) {
    return this.props.locale === JAPAN_LOCALE ? this.t(translationCode) : null
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  submitHandler(e) {
    e.preventDefault()

    this.validate()
  }

  requestRegister() {
    this.setState({ fetching: true, message: '' })

    const username = this.username()
    const url = '/signup'
    const payload = new FormData()

    payload.append('user[first_name]', this.state.firstName)
    payload.append('user[last_name]', this.state.lastName)
    payload.append('user[password]', this.state.password)
    payload.append('user[language_code]', this.props.locale)
    payload.append('identity', this.state.identity)
    payload.append('user[email]', username)
    payload.append('user[activation_code]', this.props.activationCode)
    if (!this.props.activationCode && this.props.iccid) {
      payload.append('iccid', this.props.iccid)
    }

    if (this.state.country) {
      payload.append('user[country]', this.state.country)
      payload.append('user[zipcode]', 'none')
    }

    if (this.props.region === CHINA_REGION) {
      payload.append('user[phone1]', username)
    } else {
      payload.append('user[phone1]', this.state.phone.replace(/\D+/g, ''))
    }

    this.axios.post(url, payload).then(res => {
      const { data: { errors }, status } = res

      if (status !== 200) {
        this.setState({ message: 'Failure', fetching: false })
        return
      }

      if (errors) {
        // TODO: localize
        let message = 'Failed to create new user account'

        if (errors instanceof Array && errors[0]) {
          message = errors[0].user_message || errors[0].userMessage
        }

        this.setState({
          message,
          fetching: false
        })
      } else {
        const activation_code = res.data.activation_code
          ? `?activation_code=${res.data.activation_code}`
          : ''
        window.location = `/dashboard${activation_code}`
      }
    })
  }

  checkUsernameRequest() {
    const url = '/tools/check_username'
    const payload = {
      params: {
        username: this.username()
      }
    }

    this.axios.get(url, payload).then(({ data }) => {
      if (data.success) {
        this.setState({ confirmation: true, fetching: false })
      } else {
        const flash = { type: 'alert', message: this.t('Login.AlreadyHaveAccount') }
        this.props.accountExistsHandler(this.state.email, this.state.phone, flash)
      }
    })
  }

  username() {
    let username = this.state.email

    if (this.props.region === CHINA_REGION) {
      username = this.state.phone.replace(/_/g, '').replace(/\s/g, '')
    }

    return username
  }

  changeHandler(e) {
    const { type, name } = e.target
    let value

    const errorFields = this.state.errorFields
    delete errorFields[e.target.name]

    const newState = { message: '' }

    if (name === 'password') {
      delete errorFields['confirmPassword']
    }

    if (type === 'checkbox') {
      value = e.target.checked
    } else if (type === 'file') {
      value = e.target.files[0]
      if (!this.validateIdenityFile(value.type)) {
        errorFields[name] = this.t('Register.UploadWrongFormat')
      }
    } else if (name === 'phone') { // || name === 'confirmPhone') {
      value = e.target.value.replace(/_/g, '').replace(/\s/g, '')
    } else {
      value = e.target.value

      if (value !== '' && XRegExp(validLatinChars).test(value)) {
        this.props.setFlash({ type: 'notice', message: this.t('Register.NonLatinError') })
      } else {
        this.props.setFlash()
      }

      value = XRegExp.replace(value, XRegExp(validLatinChars), '', 'all')
    }

    newState.errorFields = errorFields

    // dynamic maxLength
    const max = MAX_LENGTH_REGISTER[name]
    const bytes = byteLength(value)

    if (!max || bytes <= max || value.length < this.state.data[name].length) {
      newState[name] = value
    }

    if (bytes <= max) {
      const delta = bytes - value.length

      if (delta >= 0) {
        newState.maxLength = { ...this.state.maxLength, [name]: max - delta }
      }
    }

    this.setState(newState)
  }

  focusHandler(e) {
    e.persist()
    const value = e.target.value.replace(/_/g, '').replace(/\s/g, '')

    // if (e.target.name === 'confirmPhone') {
    //   const isChinaPhone = this.state.phone.length === 0 || this.state.phone.substr(1, 2) === '86'

    //   if (isChinaPhone === false) {
    //     return false
    //   }
    // }

    if (value === '+' && this.props.region === CHINA_REGION) {
      this.setState({
        [e.target.name]: '86',
        blurOnce: true,
      }, () => {
        // эт чтоб подвинуть курсор в конец инпута
        e.target.blur()
        e.target.focus()
      })
    }
  }

  blurHandler(e) {
    // чтобы отличить blur, вызванный из focusHandler от обычного
    if (this.state.blurOnce) {
      this.setState({ blurOnce: false })
      return
    }

    const value = e.target.value.replace(/_/g, '').replace(/\s/g, '')

    if (value === '+86') {
      this.setState({ [e.target.name]: '' })
    }
  }

  validate() {
    this.requiredFields()

    const errorFields = this.state.errorFields

    if (this.state.identity && !this.validateIdenityFile(this.state.identity.type)) {
      errorFields.identity = this.t('Register.UploadWrongFormat')
    }

    if (!this.validateEmailFormat()) {
      errorFields.email = this.t('Register.EmailWrongFormat')
    }

    // if (!this.validateEmailsMatch()) {
    //   errorFields.confirmEmail = this.t('Register.EmailsDontMatch')
    // }

    // if (!this.validatePhonesMatch() && this.props.region === CHINA_REGION) {
    //   errorFields.confirmPhone = this.t('Register.PhonesDontMatch')
    // }

    if (!this.validatePhoneValid()) {
      errorFields.phone = this.t('Shared.ErrorPhoneMsg')
    }

    if (!this.validatePasswordLength()) {
      errorFields.password = this.t('Register.ShortPassword')
    }

    if (!this.validatePasswordsMatch()) {
      errorFields.confirmPassword = this.t('Register.PasswordsDontMatch')
    }

    if (this.state.agree === false) {
      errorFields.agree = this.t('Register.ShouldAgreeWithTerms')
    }

    let valid = false
    if (Object.keys(this.state.errorFields).length === 0) {
      valid = true
    }

    if (valid) {
      this.setState({
        valid, errorFields,
        fetching: true, message: ''
      }, this.checkUsernameRequest)
    } else {
      this.setState({ valid, errorFields })
    }
  }

  requiredFields() {
    const requiredFields = ['firstName', 'lastName', 'password', 'country', 'phone']
    if (this.props.region !== CHINA_REGION) {
      requiredFields.push('email')
    }

    const reBlank = /^\s+/
    const errorFields = this.state.errorFields

    requiredFields.forEach(el => {
      const value = this.state[el]

      if (value.length === 0 || reBlank.test(value)) {
        errorFields[el] = this.t(`Register.${el}Empty`)
        this.setState({ errorFields })
      }
    })
  }

  validateIdenityFile(type) {
    if (!type) { return false }

    return [
      'image/jpeg',
      'image/png',
      'application/pdf',
    ].includes(type.toLowerCase())
  }

  validateEmailFormat() {
    if (this.state.email.length === 0) return true
    const re = /^.+@.+\..+/
    return re.test(this.state.email)
  }

  // validateEmailsMatch() {
  //   return this.state.email === this.state.confirmEmail
  // }

  // validatePhonesMatch() {
  //   return this.state.phone === this.state.confirmPhone
  // }

  validatePhoneValid() {
    const phone = this.state.isChina ? `+${this.state.phone}` : this.state.phone
    return isValidNumber(phone)
  }

  validatePasswordLength() {
    if (this.state.password.length === 0) return true
    return this.state.password.length >= 6
  }

  validatePasswordsMatch() {
    return this.state.password === this.state.confirmPassword
  }

  loginStepHandler(e) {
    e.preventDefault()
    this.props.renderLogin()
  }

  backHandler() {
    this.setState({ confirmation: false, fetching: false, message: '' })
  }

  renderCountriesSelect() {
    const { country } = this.state
    const options = sortedCountriesList(this.props.intlLocale)
      .map(([k, v], i) => {
        return <option key={i} value={k}>{v}</option>
      })

    return (
      <div className={`form-group ${this.state.errorFields.country ? 'has-error' : ''}`}>
        <select
          className={`${country === '' ? 'unselected' : ''}`}
          name="country"
          id="country"
          onChange={this.changeHandler}
          value={country}>
          <option value="">{this.t('Register.Country')}</option>
          {options}
        </select>
        <div className="form__message">
          <small className="error">{this.state.errorFields.country}</small>
        </div>
      </div>
    )
  }

  renderFirstName() {
    const { maxLength } = this.state

    return (
      <div className={`form-group ${this.state.errorFields.firstName ? 'has-error' : ''}`}>
        <input
          type="text"
          placeholder={this.t('Register.FirstName')}
          name="firstName"
          maxLength={maxLength.firstName}
          value={this.state.firstName}
          onChange={this.changeHandler}
          className="form-control"
        />
        <Hint hint={this.hintFor('Register.FirstNameHint')} />
        <div className="form__message">
          <small className="error">{this.state.errorFields.firstName}</small>
        </div>
      </div>
    )
  }

  renderLastName() {
    const { maxLength } = this.state

    return (
      <div className={`form-group ${this.state.errorFields.lastName ? 'has-error' : ''}`}>
        <input
          type="text"
          placeholder={this.t('Register.LastName')}
          name="lastName"
          maxLength={maxLength.lastName}
          value={this.state.lastName}
          onChange={this.changeHandler}
          className="form-control"
        />
        <Hint hint={this.hintFor('Register.LastNameHint')} />
        <div className="form__message">
          <small className="error">{this.state.errorFields.lastName}</small>
        </div>
      </div>
    )
  }

  renderUserNames() {
    if (this.props.region === CHINA_REGION) {
      return (
        <div>
          {this.renderLastName()}
          {this.renderFirstName()}
        </div>
      )
    }

    return (
      <div>
        {this.renderFirstName()}
        {this.renderLastName()}
      </div>
    )
  }

  render() {
    if (this.state.confirmation) {
      const {
        firstName, lastName, email, phone,
        country, message, fetching,
      } = this.state

      return (
        <div className="register">
          <h3><FormattedMessage id="Confirmation.Header" /></h3>

          <Confirmation
            firstName={firstName}
            lastName={lastName}
            email={email}
            phone={phone}
            country={country}
            backHandler={this.backHandler.bind(this)}
            register={this.requestRegister.bind(this)}
            message={message}
            fetching={fetching}
            intlLocale={this.props.intlLocale}
          />
        </div>
      )
    }

    const { maxLength, isChina } = this.state

    return (
      <div className="register">
        <h3><FormattedMessage id="Register.Header" /></h3>

        <form onSubmit={this.submitHandler.bind(this)} className="form">
          { !isChina ?
            <div className={`form-group ${this.state.errorFields.email ? 'has-error' : ''}`}>
              <input
                type="email"
                disabled={!this.props.onnet}
                placeholder={this.t('Register.Email')}
                value={this.state.email}
                name="email"
                maxLength={maxLength.email}
                onChange={this.changeHandler}
                className="form-control"
              />
              <div className="form__message">
                <small className="error">{this.state.errorFields.email}</small>
              </div>
            </div>
            : null
          }

          <div className={`form-group ${this.state.errorFields.phone ? 'has-error' : ''}`}>
            <InputMask
              type="text"
              disabled={isChina && !this.props.onnet ? true : false}
              placeholder={this.t('Register.Phone')}
              value={this.state.phone}
              name="phone"
              onChange={this.changeHandler}
              onFocus={this.focusHandler}
              onBlur={this.blurHandler}
              mask='+999999999999999'
              maskChar=""
              className="form-control"
            />
            <Hint hint={this.hintFor('Register.PhoneHint')} />
            <div className="form__message">
              <small className="error">{this.state.errorFields.phone}</small>
            </div>
          </div>

          {this.renderUserNames()}

          <div className={`form-group ${this.state.errorFields.password ? 'has-error' : ''}`}>
            <input
              type="password"
              placeholder={this.t('Register.Password')}
              value={this.state.password}
              name="password"
              maxLength="20"
              onChange={this.changeHandler}
              className="form-control"
            />
            <div className="form__message">
              <small className="error">{this.state.errorFields.password}</small>
            </div>
          </div>

          <div className={`form-group ${this.state.errorFields.confirmPassword ? 'has-error' : ''}`}>
            <input
              type="password"
              placeholder={this.t('Register.ConfirmPassword')}
              value={this.state.confirmPassword}
              name="confirmPassword"
              maxLength="20"
              onChange={this.changeHandler}
              className="form-control"
            />
            <div className="form__message">
              <small className="error">{this.state.errorFields.confirmPassword}</small>
            </div>
          </div>

          {this.renderCountriesSelect()}

          <div className="form-group">
            <div className="text-left">
              <label className='terms-and-conditions-label'>
                <input
                  type="checkbox"
                  checked={this.state.agree}
                  name="agree"
                  onChange={this.changeHandler}
                />
                <a href={`https://www.mtxc.eu/${this.props.locale === 'ru' ? 'ru' : 'en'}/privacy-policy.html`} target="_blank">
                  <FormattedMessage id="Register.TermsAndConditions" />
                </a>
              </label>
            </div>
            <div className="form__message">
              <small className="error">{this.state.errorFields.agree}</small>
            </div>
          </div>

          <div className={`form-group ${this.state.errorFields.identity ? 'has-error' : ''}`}>
            <div className="file_label_wrap text-left">
              <label>{this.t('Register.UploadIdentity')}</label>
              <small>{this.t('Register.IdentityHint')}</small>
            </div>

            <FileInput
              name="identity"
              accept="image/jpeg, image/png, application/pdf"
              placeholder={this.t('Register.ChooseFile')}
              className="file-input form-control"
              onChange={this.changeHandler}
            />
            <div className="form__message">
              <small className="error">{this.state.errorFields.identity}</small>
            </div>
          </div>

          {this.props.iccid && (
            <div style={{ marginBottom: '10px' }}>
              {this.t('Common.SIM')}: {truncateIcc(this.props.iccid)}
            </div>
          )}

          <input
            type="submit"
            className="button button-dark-blue"
            disabled={this.state.fetching}
            value={this.t('Common.Next')}
          />

          <div className="form__message">
            <small className="error">{ this.state.message.length > 0 &&  this.state.message}</small>
            { this.state.fetching &&
              <div className="wrapper">
                <div className="cssload-loader"></div>
              </div>
            }
          </div>
        </form>

        <div className="login__links">
          <div>
            <a href='' onClick={this.loginStepHandler.bind(this)}>
              <FormattedMessage id="Register.AlreadyHaveAccount" />
            </a>
          </div>
        </div>

      </div>
    )
  }
}

export default injectIntl(Register)



// WEBPACK FOOTER //
// ./app/javascript/components/application/auth/register.js